import bem from 'utils/bem';

export const block = bem('waveform-modal');
export const infoboxBlock = bem('waveform-modal-infobox');
